// extracted by mini-css-extract-plugin
module.exports = {"faq_wrapper":"faq-items_faq_wrapper__002X_","faq_items_wrapper":"faq-items_faq_items_wrapper__nBh5b"};